import Price from '~/utils/Price';
import { CalculationPrice } from '~/Api/User/ProductGroup/RoMaxPrice/CalculationPrice';
import { Error, ErrorCode } from '~/Api/User/ProductGroup/RoMaxPrice/Error';
import { ReferencedProduct } from '~/Api/User/ProductGroup/RoMaxPrice/ReferencedProduct';

export class FinalCalculation {
	biosimilarReferencePrice: Price | null;

	canamedPrice: CalculationPrice | null;

	emptyResultReason: Error[];

	fxUpdatePrice: Price | null;

	genericReferencePrice: Price | null;

	prgPrbPrice: Price | null;

	priPrice: Price | null;

	publicCatalogPrice: CalculationPrice | null;

	referencedProduct: {
		canamed: ReferencedProduct | null;
		publicCatalog: ReferencedProduct | null;
	};

	referencedProductType: string | null;

	decisionNumber: string | null;

	lossOfExclusivity: string | null;

	gtin: string | null;

	constructor(
		biosimilarReferencePrice: Price | null,
		canamedPrice: CalculationPrice | null,
		emptyResultReason: Error[],
		fxUpdatePrice: Price | null,
		genericReferencePrice: Price | null,
		prgPrbPrice: Price | null,
		priPrice: Price | null,
		publicCatalogPrice: CalculationPrice | null,
		referencedProduct: {
			canamed: ReferencedProduct | null;
			publicCatalog: ReferencedProduct | null;
		},
		referencedProductType: string | null,
		decisionNumber: string | null,
		lossOfExclusivity: string | null,
		gtin: string | null
	) {
		this.biosimilarReferencePrice = biosimilarReferencePrice;
		this.canamedPrice = canamedPrice;
		this.emptyResultReason = emptyResultReason;
		this.fxUpdatePrice = fxUpdatePrice;
		this.genericReferencePrice = genericReferencePrice;
		this.prgPrbPrice = prgPrbPrice;
		this.priPrice = priPrice;
		this.publicCatalogPrice = publicCatalogPrice;
		this.referencedProduct = referencedProduct;
		this.referencedProductType = referencedProductType;
		this.decisionNumber = decisionNumber;
		this.lossOfExclusivity = lossOfExclusivity;
		this.gtin = gtin;
	}

	hasMissingProductSettings(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.requiredProductSettingsMissing) !== undefined
		);
	}

	requiresMinOneReferenceProductErrorCode(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.requiresMinOneReferenceProduct) !== undefined
		);
	}

	findMaxOneReferenceProductError(): Error | null {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.requiresMaxOneReferenceProduct) ?? null;
	}

	isMissingReferenceSettings(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.requiresReferenceSettings) !== undefined;
	}

	isIllegalProductPriceTypeSelected(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.illegalPriceTypeSelected) !== undefined;
	}

	requiresMaxOneProductPerDataSource(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.requiresMaxOneProductPerDataSource) !== undefined
		);
	}
}
